import { mapFirstImage } from '../DataTypes/imageMapper';
import logger from '3-foundation/Logging/logger';

interface Props {
	content: {
		contentType: 'videoCard';
		properties: {
			text: Umbraco.RichText;
			poster: Umbraco.Image[];
			mediaURL: string;
		};
	};
}

export const mapVideoCard = ({ content }: Props): Content.VideoCard => {
	const { text, poster, mediaURL } = content?.properties ?? {};
	try {
		return {
			documentType: content?.contentType,
			content: {
				text: text?.markup || null,
				poster: mapFirstImage(poster),
				mediaURL: mediaURL,
			},
		};
	} catch (e) {
		logger.error('Could not map Video Card', e);
		throw new Error('Could not map Video Card', e);
	}
};
